import { GET_MAP_INFRASTRUCTURE_KEY } from '../../constants/cache';
import { ResponseError } from '../../errors/ResponseError';
import { IOSMInfrastructureResponseSchema } from '../../repositories/infrastructure-caching/entities/osm_company/OSMInfrastructureResponseSchema';
import {
  TGetInfrastructureResponse,
  fetchGetInfrastructure,
} from '../../repositories/infrastructure-caching/v1/get-infrastructure';
import { IApplicationContext } from '../../types/applicationContext';
import { TInfrastructureBbox } from '../../types/map';
import { cacheUtils } from '../../utils/cache';
import { convertBboxToString } from '../../utils/convertBboxToString';

export async function getMapInfrastructure({ httpApi, logger }: IApplicationContext, bbox: TInfrastructureBbox) {
  const parameters = {
    bbox: convertBboxToString(bbox),
  };

  // eslint-disable-next-line no-useless-catch
  try {
    const cacheKey = `${GET_MAP_INFRASTRUCTURE_KEY}_${parameters.bbox}`;
    const cachedData = cacheUtils.getCachedData<IOSMInfrastructureResponseSchema>(cacheKey);
    if (cachedData) {
      return cachedData;
    }
    const { response, statusCode }: TGetInfrastructureResponse = await fetchGetInfrastructure({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getInfrastructure',
        message: response.message || '',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    cacheUtils.setCachedData<IOSMInfrastructureResponseSchema>(cacheKey, response);

    return response;
  } catch (error) {
    logger.error(error, { domain: 'getInfrastructure' });

    throw error;
  }
}
